import { styled } from '@mui/material';

export const Pagination = styled('div')(({ theme }) => ({
  maxWidth: '100%',
  width: '1200px',
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '10px',
  margin: '0 auto',
  padding: '10px',
  paddingRight: 0,
  paddingBottom: '25px',
  // flexWrap: 'wrap',

  button: {
    padding: '8px 16px',
    cursor: 'pointer',
    color: 'white',
    border: '1px solid #ddd',
    backgroundColor: '#2C62C7',
    borderRadius: '5px',
    minWidth: '40px',
    '&.active': {
      backgroundColor: '#0B327A',
      color: 'white'
    },
    '&:disabled': {
      cursor: 'not-allowed',
      backgroundColor: '#2C62C7',
      color: 'white'
    },
    [theme.breakpoints.down('sm')]: {
      padding: '6px 12px',
      fontSize: '14px',
      margin: '2px'
    }
  }
}));

export const Ellipsis = styled('span')({
  fontSize: 20,
  color: '#0b5ed7',
  userSelect: 'none'
});
